import styled from 'styled-components/macro'

export const Wrapper = styled.p`
	display: inline-block;
	margin-bottom: 14px;
`
